import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | done | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!email || !token) { setState("error"); setMessage("This unsubscribe link is incomplete."); return; }
    api.post("/newsletter/unsubscribe", { email, token })
      .then((r) => { setState("done"); setMessage(r.data?.message || "You have been unsubscribed."); })
      .catch((e) => { setState("error"); setMessage(e?.response?.data?.detail || "We couldn't process this request."); });
  }, [email, token]);

  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center" data-testid="unsubscribe-page">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-crimson mb-3">The Fin Desk Daily</div>
      {state === "loading" && <p className="text-ink/70" data-testid="unsubscribe-loading">Processing your request…</p>}
      {state === "done" && (
        <div data-testid="unsubscribe-done">
          <h1 className="font-serif text-3xl text-ink mb-3">You're unsubscribed</h1>
          <p className="text-ink/70">{message}{email ? ` (${email})` : ""}</p>
          <p className="text-ink/60 text-sm mt-6">Changed your mind? You can <Link to="/newsletter" className="text-crimson underline">resubscribe here</Link>.</p>
        </div>
      )}
      {state === "error" && (
        <div data-testid="unsubscribe-error">
          <h1 className="font-serif text-3xl text-ink mb-3">Something went wrong</h1>
          <p className="text-ink/70">{message}</p>
          <p className="text-ink/60 text-sm mt-6"><Link to="/" className="text-crimson underline">Return to The Fin Desk</Link></p>
        </div>
      )}
    </div>
  );
}
